import { useEffect, KeyboardEvent } from 'react';

import { cancelInputEvent } from '../utils';

export const useKeysScrollBlocker = (keysName: string[]) => {
  const disableScroll = (e: KeyboardEvent<Element>) => {
    if (cancelInputEvent(e, false)) {
      return;
    }

    if (keysName.includes(e.code)) {
      e.preventDefault();
      e.stopPropagation();
      return false;
    }
  };

  useEffect(() => {
    window.addEventListener('keydown', disableScroll as never);
    return () => window.removeEventListener('keydown', disableScroll as never);
  }, []);
};
